import { render, staticRenderFns } from "./deleteIcon.vue?vue&type=template&id=a1b9cd06"
import script from "./deleteIcon.vue?vue&type=script&lang=ts"
export * from "./deleteIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports